import { normalizeError } from '@mx/pay-common';
import { toast } from '@mx/vix';
import { bridge, env, monitor, postRepayConfirm } from '@/common';
import { paymentPaySuccess, paymentPayFailOrCancel } from './callbackNativeRouter';
import { storeInstance } from '@/store';

const store = storeInstance();

/**
 * 唤起 Native 收银台
 */
function callNativeCashier(tradeno: string, payToken: string) {
  const cashierUrl = `meituanpayment://cashier/launch?trade_number=${tradeno}&pay_token=${payToken}`;
  let fail = () => {};
  // 在隐藏页面的时，若打开收银台失败，则关闭半页，并给失败或取消的回调
  if (env.hideHalfPage) {
    fail = paymentPayFailOrCancel;
  }
  bridge.openPage(cashierUrl, fail);
  // 独立收银台有bug，一直返回cancel
  KNB.unsubscribe({
    action: `cashier_callback_result_${tradeno}`, // 取消该所有事件的订阅
    success: () => {},
    fail: () => {},
  });

  KNB.subscribe({
    action: `cashier_callback_result_${tradeno}`,
    handle: (data: any) => {
      console.error('收银台回调结果::', data);
      if (data.value === 'success') {
        paymentPaySuccess();
      }
      // 在隐藏页面的时，若打开标准收银台后返回，则关闭半页，并给失败或取消的回调
      if (env.hideHalfPage && data.value === 'cancel') {
        paymentPayFailOrCancel();
      }
    },
    success: () => {},
    fail: (error: any) => {
      monitor.captureJSErrorMessage('[bridge]subscribe 订阅异常', { error: normalizeError(error) });
    },
  });
}

/**
 * 确认支付
 */
export function repayConfirm(data: any = {}) {
  const { repayInfoList } = data;
  let params: UnpaidParamsType = {
    sceneCode: env.sceneCode,
    tradeNo: env.tradeno,
    hideHalfPage: env.hideHalfPage,
    payOutSerialNo: env.payOutSerialNo,
  };
  if (repayInfoList) {
    params = {
      ...params,
      repayInfoList: JSON.stringify(repayInfoList),
    };
  }
  postRepayConfirm(params)
    .then((data) => {
      callNativeCashier(data.tradeNo, data.payToken);
    })
    .catch((error) => {
      monitor.captureAjaxErrorMessage('[api]确认支付接口请求异常', { normalizeError: normalizeError(error) });
      // 在隐藏页面的时，若请求还款接口失败，则展示半页，同时弹toast提示原因
      if (env.hideHalfPage) {
        store.commit({ type: 'payment/setShowHalfPage', showHalfPage: true });
      }
      toast.show('text', error.message, {
        duration: 2000,
      });
    });
}
